module.exports = __webpack_public_path__ + "static/media/congratulations.f24f837d.svg";